<template>
  <div id="classfoot">
    <div class="main">
      <!--核心考点-->
      <div class="hxkd">
        <h3><img src="@/assets/img/jszg_img_hxkd_title.png" alt=""><span>根据不同状态的考生定制，掌握核心考点</span></h3>
        <div class="c">
          <img src="@/assets/img/jszg_img_hxkd_content.png" alt="">
        </div>
      </div>
      <!--授课服务-->
      <div class="skfw">
        <h3><img src="@/assets/img/jszg_img_skfw_title.png" alt=""><span>完善的基础配套和服务，畅享学习乐趣</span></h3>
        <div class="c">
          <img src="@/assets/img/jszg_img_skfw_content.png" alt="">
        </div>
      </div>
      <!--成绩展示-->
      <div class="cjzs">
        <h3><img src="@/assets/img/jszg_img_cjzs_title.png" alt=""><span>16年只专注教师培训 教学口碑相传</span></h3>
        <div class="c" v-if="selectPeriodNum === 2">
          <score-list></score-list>
        </div>
        <div class="c" v-else>
          <score-list-bs></score-list-bs>
        </div>
      </div>
      <!--证书前景-->
      <div class="zsqj">
        <h3><img src="@/assets/img/jszg_img_zsqj_title.png" alt=""><span>每年数万考生在报考教师资格证</span></h3>
        <div class="c">
<!--          <img src="@/assets/img/jszg_img_zsqj_content.png" alt="">-->
          <img src="http://cdn.ysedu.com/img/modify/pic_2021062801.jpeg" alt="">
        </div>
      </div>
      <!--学习流程-->
      <div class="xxlc">
        <h3><img src="@/assets/img/jszg_img_xxlc_title.png" alt=""></h3>
        <div class="c">
          <img src="@/assets/img/jszg_img_xxlc_content.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scoreList from '../plug/scoreList'
import scoreListBs from '../plug/scoreListBs'
export default {
  name: 'classFoot',
  data () {
    return {

    }
  },
  props: [
    'selectPeriodNum'
  ],
  components: {
    scoreList,
    scoreListBs
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
  #classfoot
    padding: 0 .2rem
    background-color: #F9F9F9
    overflow: hidden
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .main
      .c
        img
          width: 100%
      h3
        display: flex
        justify-conent: flex-start
        align-items: center
        height: .5rem
        line-height: .5rem
        margin: .4rem 0
        &::before
          content: ""
          display: inline-block
          width: .08rem
          height: .4rem
          background-color: #FF7052
          margin-right: .12rem
        span
          display: inline-block
          height: .5rem
          line-height: .5rem
          padding: 0 .13rem
          margin-left: .2rem
          background-color: #F3F3F3
          font-size: .24rem
          color: #101931
          text-align: center
          -webkit-border-radius: .3rem
          -moz-border-radius: .3rem
          border-radius: .3rem
      .hxkd
        h3
          img
            width: .84rem
            height: .29rem
      .skfw
        h3
          img
            width: 1.6rem
            height: .38rem
      .cjzs
        display: none;
        h3
          img
            width: 1.6rem
            height: .36rem
      .zsqj
        h3
          img
            width: 1.61rem
            height: .38rem
      .xxlc
        h3
          img
            width: 1.61rem
            height: .37rem

</style>



// WEBPACK FOOTER //
// src/components/share/footer/classFoot.vue